import React from 'react';
import { BaseCompanyPage } from './BaseCompanyPage';
import { NotAuthorizedNavbar } from '../../Components/Navbars';

export const CompanyPageForNotAuthorized = () => {
    return (
        <>
            <NotAuthorizedNavbar />
            <BaseCompanyPage />
        </>
    );
};